// Loaded from CDN and included in externals in webpack.config.js
import MathJax from "mathjax";

// Required JS from local files
import {
  addInitialFunction,
  BOARD_ANYEXAM,
  closeDfmMessage,
  Context,
  dfmAlert,
  dfmAlertInverted,
  dfmConfirm,
  dfmDialog,
  dfmDialogCloseLast,
  dfmSkillSelector_openDialog,
  dfmTaskSetter,
  hasDirectoryPermission,
  isAdmin,
  isParent,
  isTeacher,
  isTrustAdmin,
  reportQuestionError,
} from "./dfm5";
import {
  answerSubmitHandler,
  defaultResponseFunction,
  dfm_generateQuestionContent,
  replaceMathsTags
} from "./question-util";
import { generateImagesForWorksheetNew } from "./lib-images-new.js"
import { getErrorMessageHtmlForAjaxError } from "~/utils/errors";
import { posthogPageviewEvent } from "~/utils/posthog/general";
import { posthogEventLiveGameCreated } from "~/utils/posthog/livegame";
import {
  posthogEventBlankWorksheetInitiated,
  posthogEventWorksheetBlankExamQuestionAdded,
  posthogEventWorksheetBlankGeneratedQuestionAdded,
  posthogEventWorksheetDownloaded,
  posthogEventWorksheetExamQuestionRemoved,
  posthogEventWorksheetExamQuestionChosen,
  posthogEventWorksheetExamQuestionModalClosedWithoutChoosing,
  posthogEventWorksheetExamQuestionModalOpened,
  posthogEventWorksheetExamQuestionRegenerated,
  posthogEventWorksheetExitedWithoutSaving,
  posthogEventWorksheetGeneratedFromTemplate,
  posthogEventWorksheetGeneratedQuestionChosen,
  posthogEventWorksheetGeneratedQuestionModalClosedWithoutChoosing,
  posthogEventWorksheetGeneratedQuestionModalOpened,
  posthogEventWorksheetGeneratedQuestionRegenerated,
  posthogEventWorksheetGeneratedQuestionRemoved,
  posthogEventWorksheetOpened,
  posthogEventWorksheetSaved,
  posthogEventWorksheetSwitchedToEditMode,
  posthogEventWorksheetSwitchedToViewMode,
  posthogEventWorksheetTemplateInitiated,
  posthogEventWorksheetTemplateQuestionAdded,
  posthogEventWorksheetTemplateOpened,
  posthogEventWorksheetTemplateSubskillModalOpened,
  posthogEventWorksheetTemplateSubskillModalClosedWithoutChoosing,
  posthogEventWorksheetTemplateSubskillChosen,
  posthogEventWorksheetTemplateQuestionRemoved,
  posthogEventWorksheetTemplateSaved
} from "~/utils/posthog/worksheets";

// CSS
import "./worksheets-newnew.css";

var homeDirectory;
var currentDirectory;
var currentWorksheet;
var currentTemplate;
var unsavedChanges = false;
var unsavedTemplateChanges = false;

// Used to make worksheet skill-selector usage marginally simpler when repeating
// certain actions, by remembering the last subskill selection, and the actual
// course/module/unit path that was used to select that subskill.
var mostRecentSkillPath;
var mostRecentSelectedSkills;

$(document).ready(function () {
  // Send a page view event when Context is available.
  addInitialFunction(posthogPageviewEvent);

  // Also send a page view event if we've navigated here via the bfcache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      posthogPageviewEvent();
    }
  });

  $("#worksheets-workspace").hide();
  $("#worksheets-main-menu").hide();
  $("#worksheets-main-actionbuttons button").hide();
  $("#worksheets-main-add").click(worksheetAddOptions);
  addInitialFunction(function () {
    $("#worksheet-directory").dfmDirectorySelector({ "callback": function () { saveWorksheet(false, "worksheets-directory-update-button"); }, "readOnly": !isTeacher(), "checkAddPermission": true });
    $("#template-directory").dfmDirectorySelector({ "callback": function () { saveTemplate(false, "worksheets-template-directory-update-button"); }, "readOnly": !isTeacher(), "checkAddPermission": true });

    var toPreload = (preloadState && Object.keys(preloadState).length > 0);
    console.log("[ToPreload] " + toPreload);
    if (isTeacher() || isTrustAdmin() || isParent()) {
      $("#worksheets-main-menu").show();
      loadHomeDirectory(!!toPreload);
      if (!toPreload) return; // home directory not loaded in background - so loadDirectory will be called from line above
    } else {
      $("#worksheets-main-menu").hide();
    }

    if (toPreload) {
      loadFromPageState(preloadState, false);
    } else {
      loadDirectory(1); // root directory if no directory specified in URL
    }

    window.addEventListener("beforeunload", function (e) {
      if ($("#worksheets-workspace").is(':visible') && unsavedChanges) {
        posthogEventWorksheetExitedWithoutSaving({
          triggerId: "worksheets-leave-page-without-saving",
          worksheet: getWorksheetDataForPosthogEvent(),
        });
      }
    });
  });

  $("#worksheets-directory-up").click(function () {
    loadDirectory(currentDirectory.parent);
  });
  $("#worksheets-main-home").click(function () {
    loadHomeDirectory(false);
  });
  setViewMode("view");
  $("#worksheet-vieworedit").dfmTabs();
  $("#worksheet-vieworedit").dfmTabs("setListener", function () {
    var selected = $("#worksheet-vieworedit").dfmTabs("getTab");
    const mode = selected.substr(5);
    setViewMode(mode);
    if (mode === "edit") {
      posthogEventWorksheetSwitchedToEditMode({
        triggerId: "worksheets-edit-button",
        worksheet: getWorksheetDataForPosthogEvent(),
      });
    } else {
      posthogEventWorksheetSwitchedToViewMode({
        triggerId: "worksheets-view-button",
        worksheet: getWorksheetDataForPosthogEvent(),
      });
    }
  });
  $("#worksheet-moreoptions").actionMenu({ default: "More Options", options: [] });
  $("#template-moreoptions").actionMenu({ default: "Save Options", options: [] });
  $("#back-arrow, #back-arrow-template").click(function () {
    loadDirectory();
  });

  $("#template-questions").sortable({
    items: "> li.question",
    stop: function () {
      renumberQuestions();
      madeChanges(true);
    },
    helper: "clone"
  });

  $("#add-examquestion").on("click", function () {
    addExamQuestion(true);
    makeQuestionsClickable(prevViewMode == "edit");

    const worksheet = getWorksheetDataForPosthogEvent();
    posthogEventWorksheetBlankExamQuestionAdded({
      triggerId: "worksheets-add-exam-question-button",
      questionNumber: worksheet.questions.length,
      worksheet,
    });
  });

  $("#add-keyskillquestion").on("click", function () {
    addGeneratedQuestion(true);
    makeQuestionsClickable(prevViewMode == "edit");

    const worksheet = getWorksheetDataForPosthogEvent();
    posthogEventWorksheetBlankGeneratedQuestionAdded({
      triggerId: "worksheets-add-generated-question-button",
      questionNumber: worksheet.questions.length,
      worksheet,
    });
  });

  $("#template-addquestion-button button").on("click", function () {
    addTemplateQuestion(true);

    const template = getTemplateDataForPosthogEvent();
    posthogEventWorksheetTemplateQuestionAdded({
      triggerId: "worksheets-add-template-question-button",
      questionNumber: template.questions.length,
      template,
    });
  });

  $("#button-save").click(function () {
    return saveWorksheet(false, "worksheets-save-button");
  });
  $("#button-saveas").click(function () {
    return saveWorksheet(true, "worksheets-save-as-button");
  });
  $("#button-practise").on("click", () => practiseWorksheet("worksheets-practise-this-worksheet-button"));

  $("#button-export").click(function () {
    const invalidQuestions = getInvalidQuestions();
    if (invalidQuestions.length > 0) {
      dfmAlert(buildInvalidQuestionsMessage(invalidQuestions));
      return;
    }

    if (unsavedChanges) {
      dfmAlert("Please save any existing changes to your worksheet (or save as a new worksheet) before exporting it.");
      return;
    }

    var questions = [];

    $(".question-area").each(function () {
      if ($(this).data("question")) {
        questions.push($(this).data("question"));
      }
    });

    if (questions.length > 30) {
      dfmAlert("Unfortunately this worksheet exceeds the limit for download. Please reduce the size of the worksheet to 30 questions or fewer.");
    } else {
      generateImagesForWorksheetNew(questions, function () {
        dfmDialog((questions.length >= 25 ? "<p style='color: darkred;'><strong>Warning:</strong> This worksheet may take a while to download.</p>" : "")
          + "<h2>Export Options</h2><input type=checkbox value='1' name=removeexamcodes checked id='c-removeexamcodes'> <label for='c-removeexamcodes'>Remove exam question reference tags</label><br>"
          + "<input type=checkbox value='1' checked name=minimisespace id='c-minimisespace'> <label for='c-minimisespace'>Minimise spacing for answer input</label><br>"
          + "<label><input type=checkbox value='0' checked name=includeskillnames> Include skill names with each question</label><br>"
          + "<br>",
          [{
            label: "Generate", action: function () {
              var url = "/api/worksheets/export/" + currentWorksheet.wid + "?"
              var options = [];

              if ($("input[name=removeexamcodes]").is(":checked")) options.push("removeExamTags=1");
              if ($("input[name=minimisespace]").is(":checked")) options.push("minimiseSpace=1");
              if ($("input[name=includeskillnames]").is(":checked")) options.push("includeSkillNames=1");
              url += options.join("&");

              console.log(url);
              var win = window.open(url, '_blank');
              win.focus();
              dfmAlert("Your worksheet is being generated and will appear in your download bar shortly.");

              posthogEventWorksheetDownloaded({
                triggerId: "worksheets-generate-button",
                worksheet: getWorksheetDataForPosthogEvent(),
              })
            }
          }]
        );
      });
    }
  });

  $("#button-fullscreen").click(toggleFullscreen);

  $("#button-setaswork").click(function () {
    const invalidQuestions = getInvalidQuestions();
    if (invalidQuestions.length > 0) {
      dfmAlert(buildInvalidQuestionsMessage(invalidQuestions));
      return;
    }

    if (unsavedChanges) {
      dfmAlert("Please save any existing changes to your worksheet (or save as a new worksheet) before setting these questions to students.");
      return;
    }

    // TAS-517: Disallow setting a task on an empty worksheet.  (It should be impossible to save while empty, and thus
    //          be caught by the previous condition, but let's double-check here in case of an upstream bug)
    if ($(".question-area").length < 1) {
      dfmAlert("Please add at least one question to the worksheet before setting it to students.");
      return;
    }

    dfmDialog("<ul id='task-type-options'></ul>", [{
      label: "Continue", action: function () {
        var choice = $("input[name=task-type-option]:checked").val();
        dfmDialogCloseLast();
        if (choice == "normal") {
          updateTotalMarks();
          dfmTaskSetter({
            isPractice: false,
            task: { wid: currentWorksheet.wid, _worksheet: currentWorksheet, type: 't' },
            heading: currentWorksheet.name,
            posthogTriggerId: "worksheets-normal-task-set-button",
          });
        }
        else if (choice == "live") {
          startLiveGame();
        }
      }
    }]);
    $("#task-type-options").append("<li><label><input type='radio' name='task-type-option' value='normal'><h2>Normal task</h2><h3>Students complete questions at their own pace, either as homework or as a class task.</label></li>");
    $("#task-type-options").append("<li><label><input type='radio' name='task-type-option' value='live'><h2>Live! task</h2><h3>Students play along with their mobile/tablet device. Students all answer a question at the same time, with the game controlled by the teacher.</label></li>");
    $("input[value=normal]").prop('checked', true);
  }
  );

  $("#button-templategenerate").on("click", async function () {
    await generateRandomWorksheet();

    posthogEventWorksheetGeneratedFromTemplate({
      triggerId: "worksheets-generate-button",
      worksheet: getWorksheetDataForPosthogEvent(),
      template: getTemplateDataForPosthogEvent(),
    });
  });

  $("#worksheets-directory-sort").change(function () {
    console.log("[UpdatedSort]");
    loadDirectory();
  });

  $("#worksheets-main-delete").click(deleteSelection);
  $("#worksheets-main-move").click(moveSelection);
  $("#worksheets-main-edit").click(editSelection);

});

function startLiveGame() {
  if (!Context.user) {
    dfmAlert("This functionality is available only to registered users. <a href='register.php'>Click to register</a>.");
    return;
  }
  if (unsavedChanges) {
    dfmAlert("Please save any existing changes to your worksheet (or save as a new worksheet) before starting a Live! game.");
  } else {
    var inputHTML = "";
    inputHTML += "<strong>Select an option for participants</strong><br><small>This allows you to control whether login is required to join the game, and whether participants are allowed to use a custom nickname.</small>";
    inputHTML += "<select name='livemode' style='margin-top:10px'><option value='0'>DFM login required (no nicknames)</option><option value='1'>DFM login required (nicknames allowed)</option><option value='2'>Guests allowed</option>" + ((Context.user.type == 'teacher' || Context.user.type == 'admin') ? "<option value='3'>Select a class</option>" : "") + "</select>";
    if (Context.user.type == 'teacher' || Context.user.type == 'admin') {
      inputHTML += "<input type='hidden' name='liveclass'>";
    }
    inputHTML += "<br><br><strong>Select a points mode</strong><br><small>In the normal mode, the fastest correct answer gets 1000 points, with a minimum of 500 for a correct answer.</small>";
    inputHTML += "<br><select name='pointsmode' style='margin-top:10px'><option value='0' selected>Faster answers get more points</option><option value='1'>No speed bonus</option></select>";
    inputHTML += "<br><br><strong>What appears on student screens?</strong><br><small>If you're doing the game remotely, choose for the question to appear on your students' screens.</small>";
    inputHTML += "<br><select id='studentdisplay' name='studentdisplay' style='margin-top:10px'><option value='0' selected>Answer input only</option><option value='1'>Question and answer input</option></select>";


    dfmDialog(inputHTML + "<br><br>", [{
      label: "Start Game", action: function () {
        const options = {
          wid: currentWorksheet.wid,
          entrymode: Number($("select[name=livemode]").val()),
          pointsmode: Number($("select[name=pointsmode]").val()),
          studentdisplay: Number($("select[name=studentdisplay]").val())
        };

        if ($("select[name=livemode]").val() == 3) {
          options.cid = JSON.parse($("input[name='liveclass']").val()).cids[0];
        }

        $.ajax({
          url: "/api/live/startgame",
          type: "POST",
          context: document.body,
          dataType: "json",
          data: JSON.stringify(options),
          success: function (data) {
            if (data.gid) {
              const worksheet = getWorksheetDataForPosthogEvent();
              const questions = worksheet.questions ?? [];
              posthogEventLiveGameCreated({
                triggerId: "worksheets-start-live-game-button",
                gid: data.gid,
                options: {
                  ...options,
                  numquestions: questions.length,
                },
                worksheet,
              });
           }
           window.location = "live-hub.php";
          },
          error: function (j, textStatus, errorThrown) {
            console.error(j.responseText);
            dfmAlert("There was an error starting the game.");
          }
        });
      }
    }]);

    $("input[name=liveclass]").studentSelector({ "classesOnly": true });


    $("select[name=livemode]").change(function () {
      if ($(this).val() == 3) $("input[name=liveclass]").next().show();
      else $("input[name=liveclass]").next().hide();
    }).change();

  }

}

function hasQuestions() {
  return $(".question-area").toArray().some(q => $(q).data("question"));
}

function getInvalidQuestions() {
  return $(".question-area")
    .toArray()
    .map((q, i) => ({ qNum: i + 1, question: $(q).data("question") }))
    .filter(({ question }) => question?.isValid === false || question?.failedToRenderOnClient === true)
    .map(({ qNum }) => `Q${qNum}`);
}

function buildInvalidQuestionsMessage(invalidQuestions) {
  return `<div>
      <h4 style="font-size: 18px; margin: 16px 0;">Your worksheet contains errors 🚧</h4>
      <p>Please remove or replace the following question(s):</p>
      <p style="font-size: 18px;"><b>${invalidQuestions.join(", ")}</b></p>
  </div>`;
}

function hasWorksheetEditAccess(isTemplate) {
  // For the moment, only edit access of worksheet/template if the creating user (or an admin). Trust admins can edit worksheets within the trust.
  if (!Context.user) return false;
  if (Context.user.type == "student") return false;
  if (Context.user.type == "admin") return true;
  if (isTemplate && !currentTemplate) return true;  // creating a new template (yet to be saved)
  if (!isTemplate && !currentWorksheet) return true; // creating a new worksheet
  var itemUid = (isTemplate ? currentTemplate.uid : currentWorksheet.uid);
  var itemSid = (isTemplate ? currentTemplate.sid : currentWorksheet.sid);
  var itemAcid = (isTemplate ? currentTemplate.acid : currentWorksheet.acid);
  if (Context.user.type == "trust") {
    console.log("ITEMUID: " + itemUid + " ITEMSID: " + itemSid + " ITEMACID: " + itemAcid);
    return Context.user.uid == itemUid || Context.user.sid == itemSid || Context.user.acid == itemAcid;
  }
  return Context.user.uid == itemUid;
}


function deleteWorksheet(isTemplate) {
  dfmConfirm("Are you sure you want to delete this " + (isTemplate ? "template" : "worksheet") + "? This can't be undone.", function () {
    var url = "";

    if (isTemplate) {
      url = "/api/worksheets/template/" + currentTemplate.wtid;
    } else {
      url = "/api/worksheets/worksheet/" + currentWorksheet.wid;
    }

    $.ajax({
      url: url,
      type: "DELETE",
      context: document.body,
      dataType: "json",
      success: function (data, textStatus, jqXHR) {
        loadDirectory();
      },
      error: function (j, textStatus, errorThrown) {
        const errorMessageHtml = getErrorMessageHtmlForAjaxError(j, "There was an error deleting the worksheet.");
        dfmAlert(errorMessageHtml);
      }
    });
  });
}

function practiseWorksheet(posthogTriggerId = null) {
  var taskOptions = {
    isPractice: true,
    task: { wid: currentWorksheet.wid, _worksheet: currentWorksheet, type: 'c' }
  }
  if (posthogTriggerId) {
    taskOptions.posthogTriggerId = posthogTriggerId;
  }
  if (Context.user) taskOptions.task.recipients = { uids: [Context.user.uid] }; // set to themselves!
  dfmTaskSetter(taskOptions);
}

function generateShadowPaper() {
  let worksheetId = currentWorksheet.wid;
  $.ajax({
    url: "/api/worksheets/worksheettotemplate/" + worksheetId,
    contentType: false,
    processData: false,
    type: "GET",
    dataType: "json",
    cache: false,
    success: function (template, textStatus, jqXHR) {
      loadTemplate(template);

      posthogEventWorksheetTemplateInitiated({
        triggerId: "worksheets-generate-shadow-paper",
        template: getTemplateDataForPosthogEvent({ discardType: true }),
        shadowWorksheetId: worksheetId,
      });
    },
    error: function (j, textStatus, errorThrown) {
      $.modal.close();
      dfmAlert("There was an error generating the template from the worksheet:<br><br><strong>" + j.responseText + "</strong>");
    }
  });

}

function worksheetAddOptions() {
  dfmAlertInverted(""
    + "<div class='dialog-options'>"
    + "<div><button id='worksheet-add-worksheet'>+ Worksheet</button><p>A worksheet is a collection of questions that can be set to students as an online task, or exported to Word.</p></div>"
    + "<div><button id='worksheet-add-template'>+ Template</button><p>A template is a specification of how to generate a random worksheet, based on the skills you want.</p></div>"
    + "<div><button id='worksheet-add-directory'>+ Directory</button><p>Add a new directory within the current one.</p></div>"
    + "</div>");
  $("#worksheet-add-worksheet").on("click", function() {
    newWorksheet(false);

    posthogEventBlankWorksheetInitiated({
      triggerId: "worksheets-new-worksheet-button"
    });
  });
  $("#worksheet-add-template").on("click", function () {
    newWorksheet(true);

    posthogEventWorksheetTemplateInitiated({
      triggerId: "worksheets-new-template-button",
      template: getTemplateDataForPosthogEvent(),
    });
  });
  $("#worksheet-add-directory").click(newDirectory);

  if (!hasDirectoryPermission(currentDirectory, 'a')) {
    $("#worksheet-add-directory").prop('disabled', true);
    $("#worksheet-add-directory").next().addClass('disabled'); // the description text
  }

}

async function loadTemplate(template) {
  // TODO This should really be merged with loadWorksheet(isTemplate=true), although that loads by template id.
  newWorksheet(true);
  currentTemplate = template;
  addTemplateQuestions(currentTemplate.questions);
  if (template.name) $("#template-titles h1").html(template.name);

  await generateRandomWorksheet();

  posthogEventWorksheetGeneratedFromTemplate({
    triggerId: "worksheets-initial-generation-from-template",
    worksheet: getWorksheetDataForPosthogEvent(),
    template: getTemplateDataForPosthogEvent(),
  });
}

function instantiateActionMenu(isTemplate) {
  var actionOptions = [];
  if (isTemplate) {

    var actionOptions = [{
      label: "Save Template", action: function () {
        saveTemplate(false, "worksheets-save-template-option");
      }
    },
    {
      label: "Save Template As", action: function () {
        saveTemplate(true, "worksheets-save-template-as-option");
      }
    }];
    if (hasWorksheetEditAccess(true) && currentTemplate) actionOptions.push({
      label: "Delete Template", action: function () {
        deleteWorksheet(true);
      }
    });
    $("#template-moreoptions").actionMenu("setOptions", actionOptions);

  } else {

    if (hasWorksheetEditAccess(false) && currentWorksheet) {
      actionOptions.push({ label: "Delete Worksheet", action: deleteWorksheet });
    }
    actionOptions.push({ label: "Generate Shadow Paper", action: generateShadowPaper });
    actionOptions.push({ label: "Try as a student", action: () => practiseWorksheet("worksheets-try-as-student-option") });
    $("#worksheet-moreoptions").actionMenu("setOptions", actionOptions);

  }
}

function reportErrorDialog(qid) {
  dfmAlert(`<p>Please email <a href='mailto:support@drfrost.org'>support@drfrost.org</a> with the details of the question and error. Please reference Question ID ${qid}.</p>`);
}

function loadWorksheet(wid, isTemplate, posthogTriggerId = null) {
  $("#worksheets-browser").hide();
  $("#worksheets-workspace").show();
  $("#worksheet-titles h1").html("-").unbind('click').removeClass('editable');
  $("#template-titles h1").html("-").unbind('click').removeClass('editable');
  $("#worksheet-addquestion-button").prevAll().remove();
  $("#worksheets-workspace").toggleClass('template-mode', isTemplate);
  $("#worksheet-menu-teacher, #worksheet-menu-student").hide();
  $("#worksheet-furthermenu").hide();

  $.ajax({
    url: "/api/worksheets/" + (isTemplate ? "template" : "worksheet") + "/" + wid,
    type: "GET",
    contentType: false,
    processData: false,
    cache: false,
    dataType: "json",
    success: function (worksheet) {
      console.log(JSON.stringify(worksheet));
      $("#worksheet-titles h1").html(worksheet.name);

      if (isTemplate) currentTemplate = worksheet;
      else currentWorksheet = worksheet;
      unsavedChanges = false;
      unsavedTemplateChanges = false;

      currentPageState = isTemplate ? { wtid: wid } : { wid: wid };
      saveState("DFM - " + worksheet.name, isTemplate ? "?wtid=" + wid : "?wid=" + wid);

      if (!currentDirectory || currentDirectory.wdid != worksheet.parent) currentDirectory = { wdid: worksheet.parent };

      if (!isTemplate) {
        $("#worksheet-questions").show();

        removePendingWorksheetMessage();
        if (worksheet.status === 2) {
          showPendingWorksheetMessage(worksheet.wid);
        }

        if (isTeacher() || isTrustAdmin() || isParent()) {
          $("#worksheet-menu-teacher").show();
          $("#worksheet-furthermenu").show();
        } else $("#worksheet-menu-student").show();


        $("#button-save").toggle(hasWorksheetEditAccess(false));
        instantiateActionMenu(false);

        $("#button-save").prop('disabled', true);
        $("#button-share").prop("disabled", false);
        $("#back-arrow").show();
        $(".instructional-message").remove();
        $("#worksheet-menu-buttons button").prop("disabled", false);
        $("#worksheet-menu-buttons input[type=radio]").prop("disabled", false);

        if (hasWorksheetEditAccess(false)) $("#worksheet-titles h1").addClass('editable').unbind('click').click(function () {
          updateWorksheetName(false);
        });

        $("#worksheet-menu").show();
        setViewMode("view");
        // console.log(JSON.stringify(worksheet));
        if (Context.user && Context.user.type === "admin") worksheet.istopictest = false; // give admins special privilege
        $("#button-saveas").prop('disabled', worksheet.istopictest);
        $("#button-live").prop('disabled', worksheet.istopictest);
        $("#button-practise").prop('disabled', worksheet.istopictest);
        $("input[name=vmode]").prop('disabled', worksheet.istopictest);

        $("#worksheet-menu h1 span").html(currentWorksheet.title);
        $("#worksheet-menu h1 input").val(currentWorksheet.title);
        $("#worksheet-directory").val(currentWorksheet.parent);
        $("#worksheet-directory").dfmDirectorySelector("update");

        $.each(worksheet.questions, function (key, q) {

          console.log("-- Question " + (key + 1));
          if (!q.qid) addGeneratedQuestion(false);
          else addExamQuestion(false);

          var container = $("#worksheet-questions").children().last().prev().find(".question-area");
          putQuestionInBox(q, container, false);

          // Inject the skill data into the container for skill-selector reference when editing.
          // We can't retrieve the original course/module/unit path used to add it, so we'll have
          // to find it within the all-skills course, as and when we load the selector dialog.
          container.data('selectedSkills', {
            skids: [],
            ssids: q.subskill?.ssid ? [q.subskill.ssid] : []
          });
          container.data('skillPath', { useAllSkills: true });

          var editPermission = hasWorksheetEditAccess(false);
          if (q.qid) {
            container.after(
              "<div class='report-error-link' style='margin-top:10px'>"
              + "<span id='report-error-" + q.qid + "' style='color: #1A73E8; cursor: pointer; font-size: 12px; font-weight: 700;'>Report Error</span>"
              + (
                editPermission ?
                  "<a id='q-" + q.qid + "-edit' style='font-size:12px;margin-left:20px' href='add-question.php?qid=" + q.qid + "' target='_blank'>Edit</a>" : ""
              )
              + "</div>");
            $(`#report-error-${q.qid}`).on("click", () => reportQuestionError(q.qid));
          }

          container.parent().children("h1").children('span').first().addClass('qnum');
          if (!Context.user || Context.user.type === "student" || Context.user.type === "other") {
            container.find('input[type=submit]').unbind('click');
            container.find('input[type=submit]').click(function () {
              dfmAlert("Please click the <strong>Practise This Worksheet</strong> button above.");
              return false;
            });
          }
        });

        $("#worksheet-questions").scrollTop(0);
        $(window).resize();

        if (hasWorksheetEditAccess(false)) startAutosaveTimer();

      } else {

        $("#template-directory").val(currentTemplate.parent);
        $("#template-directory").dfmDirectorySelector("update");
        $("#template-titles h1").html(currentTemplate.name);
        addTemplateQuestions(currentTemplate.questions);

        instantiateActionMenu(true);
      }

      updateTotalMarks();
      MathJax.typeset();

      if (posthogTriggerId && !isTemplate) {
        posthogEventWorksheetOpened({
          triggerId: posthogTriggerId,
          worksheet: getWorksheetDataForPosthogEvent(),
        });
      }

      if (posthogTriggerId && isTemplate) {
        posthogEventWorksheetTemplateOpened({
          triggerId: posthogTriggerId,
          template: getTemplateDataForPosthogEvent({ discardType: true }),
        });
      }
    },
    error: function (j, textStatus, errorThrown) {
      dfmAlert("An error occurred when trying to get this worksheet: <strong>" + j.responseText + "</strong>");
    }
  });
}

function removePendingWorksheetMessage() {
  $("#worksheet-pending-qa").remove();
}

function showPendingWorksheetMessage(wid) {
  $("#worksheet-furthermenu").after(
    `<div id="worksheet-pending-qa">
      ⏳ Pending QA - this worksheet can be edited but it will not be publicly available until it has been approved by an admin
      ${isAdmin() ? "<button>Approve</button>": ""}
    </div>`
  );

  $("#worksheet-pending-qa button").on("click", () => {
    dfmConfirm("The worksheet will be made active and therefore publicly available. Any questions that are pending approval will also be marked as approved. Are you sure you want to continue?", async () => {
      try {
        const response = await fetch(`/api/worksheets/worksheet/${wid}/approve`, { method: "POST" });
        if (!response.ok) {
          throw new Error();
        }
        removePendingWorksheetMessage();
      } catch (e) {
        dfmAlert("There was an error approving the worksheet.");
      }
    });
  });
}

function updateWorksheetName(isTemplate) {
  dfmDialog("<label style='display:inline-block;width:70px'>Name:</label><input type='text' id='new-name'>", [{
    label: "Update", action: function () {
      const originalName = $("#worksheet-titles h1").html();

      // We have to update the name before saving, because saveWorksheet() reads
      // it back out from the DOM
      $("#worksheet-titles h1").html($("#new-name").val());

      // ...But if the save fails, we probably want to restore it, otherwise the
      // UI gets out of whack, so we'll attach it as data
      $("#worksheet-titles h1").data('originalName', originalName);

      saveWorksheet(false, "worksheets-name-update-button");
    }
  }]);
  $("#new-name").val($("#worksheet-titles h1").html()).focus();
}

function addExamQuestion(singleAdd) {
  $("#worksheet-addquestion-button").before("<li class='question' data-question-type='exam'><h1><a href='#'>&times;</a><span class='qnum'>Question</span></h1><div class='question-area choose-question'><p>Click to choose an exam question.</p></div></li>");
  if (singleAdd) {
    var scroll = $("#worksheet-questions").children().last().offset().top - $("#worksheet-questions").offset().top + $("#worksheet-questions").scrollTop();
    $("#worksheet-questions").animate({ scrollTop: scroll }, "slow");
  }
  $("#worksheet-addquestion-button").prev().find("h1 a").click(function () {
    const container = $(this).parent().parent().find(".question-area");
    const question = container.data("question");
    const qnum = container.parent().data("qnum");

    $(this).parent().parent().remove();
    renumberQuestions();
    madeChanges(false);

    posthogEventWorksheetExamQuestionRemoved({
      triggerId: "worksheets-exam-question-card-remove-button",
      questionNumber: qnum,
      question,
      worksheet: getWorksheetDataForPosthogEvent(),
    });
  });
  renumberQuestions();
  if (singleAdd) madeChanges(false);
}

function addGeneratedQuestion(singleAdd) {
  $("#worksheet-addquestion-button").before("<li class='question' data-question-type='generated'><h1><a href='#'>&times;</a><span class='qnum'>Question</span></h1><div class='question-area choose-question'><p>Click to create a randomly generated question.</p></div></li>");
  if (singleAdd) {
    var scroll = $("#worksheet-questions").children().last().offset().top - $("#worksheet-questions").offset().top + $("#worksheet-questions").scrollTop();
    $("#worksheet-questions").animate({ scrollTop: scroll }, "slow");
  }
  $("#worksheet-addquestion-button").prev().find("h1 a").click(function () {
    const container = $(this).parent().parent().find(".question-area");
    const question = container.data("question");
    const qnum = container.parent().data("qnum");

    $(this).parent().parent().remove();
    renumberQuestions();
    madeChanges(false);

    posthogEventWorksheetGeneratedQuestionRemoved({
      triggerId: "worksheets-generated-question-card-remove-button",
      questionNumber: qnum,
      question,
      worksheet: getWorksheetDataForPosthogEvent(),
    })
  });
  renumberQuestions();
}


function renumberQuestions() {
  $("#worksheet-questions").find("h1 .qnum").each(function (i) {
    $(this).html("Question " + (parseInt(i) + 1));
    $(this).closest('li').data('qnum', parseInt(i) + 1); // save question number to overall question container
  });
  $("#template-questions").find("h1 .qnum").each(function (i) {
    $(this).html("Question " + (parseInt(i) + 1));
  });
}

function putQuestionInBox(question, container, singleAdd) {
  container.removeClass("choose-question");
  container.data("question", question);
  if (question.content) {
    const renderedSuccessfully = dfm_generateQuestionContent(container, question, function () {
      return answerSubmitHandler(container,
        function (qArea) {
          defaultResponseFunction(container)(qArea);
          $('input[type=submit]').prop('disabled', false);
        }
      )
    });
    /**
     * This flag is used by getInvalidQuestions to determine
     * if the worksheet contains questions that failed to
     * render.
     */
    question.failedToRenderOnClient = !renderedSuccessfully;
    if (singleAdd) MathJax.typeset();
  }

  container.parent().find('.difficulty, .ks-indicator, .worksheetregenerate').remove();
  if (question.difficulty) container.parent().children("h1").append("<span class='difficulty'>" + question.difficulty + "</span>");

  container.parent().find(".difficulty").each(function () {
    $(this).dfmLevelBar();
    $(this).css('margin-left', '30px');
  });


  container.data("question", question);
  if (singleAdd) madeChanges(false);
}


// ----------------------------------------
// -- DIRECTORY & HOME DIRECTORY LOADING
// ----------------------------------------



function loadHomeDirectory(inBackground) {
  if (!Context.user) return;
  console.log("[LoadingHomeDirectory] inBackground = " + inBackground);
  $.ajax({
    url: "/api/worksheets/userhomedirectory",
    type: "GET",
    contentType: false,
    processData: false,
    cache: false,
    dataType: "json",
    success: function (homeDirec) {
      homeDirectory = homeDirec;
      // Need to properly load directory to get ancestors and children.
      if (!inBackground) loadDirectory(homeDirec.wdid);
    },
    error: function (j, textStatus, errorThrown) {
      dfmAlert("An error occurred when trying to get the home directory: <strong>" + j.responseText + "</strong>");
    }
  });

}

function loadDirectory(wdid) {
  console.log("[LoadDirectory] wdid=" + wdid);
  if ($("#worksheets-workspace").is(':visible') && unsavedChanges) {
    dfmConfirm("You have unsaved changes. Are you sure you want to exit?", function () {
      loadDirectoryComplete(wdid);
      posthogEventWorksheetExitedWithoutSaving({
        triggerId: "worksheets-exit-without-saving",
        worksheet: getWorksheetDataForPosthogEvent(),
      });
    });
  } else {
    loadDirectoryComplete(wdid);
  }
}

function loadDirectoryComplete(wdid) {
  if (!wdid) wdid = (currentDirectory ? currentDirectory.wdid : 1); // useful for reloading a directory.
  $("#worksheets-browser").show();
  $("#worksheets-workspace").hide();
  $(window).resize();

  var url = "/api/worksheets/directory/" + wdid + "?sort=" + $("#worksheets-directory-sort").val();
  console.log(url);
  $.ajax({
    url: url,
    type: "GET",
    contentType: false,
    processData: false,
    cache: false,
    dataType: "json",
    success: function (directory) {
      console.log(JSON.stringify(directory));
      currentDirectory = directory;
      $("#worksheets-directory-titles h1").html(directory.name);
      $("#worksheets-directory-titles h2").html(directory.description ? directory.description : "-");
      $("#worksheets-directory").empty();
      $("#worksheets-directory-menu, #worksheets-left").toggle(directory.wdid != 1);

      currentPageState = directory;
      saveState("DFM - " + directory.name, "?wdid=" + directory.wdid);

      $.each(directory._children, function (k, child) {
        let id;
        let thumb = "/images/directory_icon.svg";
        let subtext = "";


        if (child.type == "worksheet") {
          id = "ww" + child.wid;
          subtext = child.numquestions + " question" + (child.numquestions == 1 ? "" : "s");
        }
        else if (child.type == "template") {
          id = "wt" + child.wtid;
          subtext = child.numquestions + " question" + (child.numquestions == 1 ? "" : "s");
        } else {
          id = "wd" + child.wdid;
          subtext = child.numfiles + " worksheet" + (child.numfiles == 1 ? "" : "s");
        }
        if (child.thumb) thumb = child.thumb;
        else if (child.type == "worksheet") thumb = "/images/worksheet_icon.svg";
        else if (child.type == "template") thumb = "/images/template_icon.svg";
        var checkboxHTML = "";
        if (hasEditAccess(child)) checkboxHTML = "<input type='checkbox'>";
        $("#worksheets-directory").append("<li id='" + id + "'>" + checkboxHTML + "<a href='#'><img src='" + thumb + "'><h1>" + child.name + "</h1>"
          + "<h2>" + subtext + "</h2>"
          + (child.description ? "<p>" + child.description + "</p>" : "")
          + "</a></li>");
        $("#" + id).data('item', child);
        if (child.type == "worksheet" && child.status === 2) {
          $("#" + id).addClass("pending");
        }
        $("#" + id).click(function () {
          var item = $(this).data('item');
          if (item.type == "directory") loadDirectory(item.wdid);
          else if (item.type == "worksheet") loadWorksheet(item.wid, false, "worksheets-worksheet-file-tile");
          else if (item.type == "template") loadWorksheet(item.wtid, true, "worksheets-template-file-tile");
        });
        $("#" + id).find('input[type=checkbox]').click(function (e) {
          e.stopPropagation();
          var itemDOM = $(this).closest('li');
          itemDOM.toggleClass('selected', $(this).is(':checked'));
          respondToItemSelection();
          if (e.shiftKey) {
            var li = $(this).closest('li');
            var first = li.parent().children('.selected').first();
            var last = li.parent().children('.selected').last();
            var current = first;
            while (current.attr('id') != last.attr('id')) {
              current = current.next();
              if (current.attr('id') != last.attr('id')) {
                current.addClass('selected');
                current.find('input[type=checkbox]').prop('checked', true);
              }
            }
            respondToItemSelection();
          }
        });
      });
      $("#worksheets-directory").scrollTop(0);
      if (directory._children.length == 0) $("#worksheets-directory").append("<p class='directory-empty-message'>This directory is empty. Use the <strong>+New</strong> button to add a new directory or worksheet.</p>");

      // Rebuild menu.
      $("#worksheets-menu").empty();

      // Coalesce ancestor list into one tree.
      var ancestorsTree = directory._ancestors ?? [];
      if (ancestorsTree.length > 0) {
        for (var i = 0; i < ancestorsTree.length - 1; i++) {
          for (var j = 0; j < ancestorsTree[i]._children.length; j++) {
            var child = ancestorsTree[i]._children[j];
            if (child.wdid == ancestorsTree[i + 1].wdid) {
              ancestorsTree[i]._children[j] = ancestorsTree[i + 1];
            }
          }
        }
        populateLeftTree($("#worksheets-menu"), ancestorsTree[0]);
      }


      $(window).resize();
      respondToItemSelection();
    },
    error: function (j, textStatus, errorThrown) {
      dfmAlert("An error occurred when trying to get the directory=" + wdid + ": <strong>" + j.responseText + "</strong>");
    }
  });

}

function deleteSelection() {
  var items = getItemSelection();
  dfmConfirm("Are you sure you want to delete these items? This cannot be undone.", function () {
    doSelectionAction(items, "delete");
  });
}

function moveSelection() {
  var items = getItemSelection();
  var inputTxt = "<h1>Move selection to another directory</h1>";
  inputTxt += "<div><input type='hidden' name='location'></div>";

  dfmDialog(inputTxt, [{
    label: "Submit", action: function () {
      doSelectionAction(items, "move", Number($("input[name=location]").val()));
    }
  }]);
  $("input[name=location]").val((currentDirectory && Context.user.sid && currentDirectory.sid == Context.user.sid) ? currentDirectory.wdid : homeDirectory.wdid); // default to current directory (provided it belongs to same school as the user), else user's home directory.
  $("input[name=location]").dfmDirectorySelector({ "checkAddPermission": true });
  $("input[name=location]").next().css('max-width', '270px').css('vertical-align', 'top').css('margin-top', '5px');

}

function doSelectionAction(items, action, parent) {
  // action is "delete" or "move". If "move", parent is the destination directory.
  // First, convert items into a form for sending.
  var itemsToSend = [];
  $.each(items, function (k, item) {
    if (item.type == "worksheet") itemsToSend.push({ type: item.type, id: item.wid });
    else if (item.type == "template") itemsToSend.push({ type: item.type, id: item.wtid });
    else if (item.type == "directory") itemsToSend.push({ type: item.type, id: item.wdid });
  });
  var data = { items: itemsToSend };
  if (action == "move") data.parent = parent;

  console.log("/api/worksheets/multi/" + action);
  $.ajax({
    url: "/api/worksheets/multi/" + action,
    type: (action == "move" ? "PATCH" : "DELETE"),
    contentType: false,
    processData: false,
    cache: false,
    data: JSON.stringify(data),
    success: function (data) {
      loadDirectory(); // reload current directory
    },
    error: function (j, textStatus, errorThrown) {
      const errorMessageHtml = getErrorMessageHtmlForAjaxError(j, `There was an error when attempting to ${action} the worksheet.`);
      dfmAlert(errorMessageHtml);
    }
  });

}

function getItemSelection() {
  var items = [];
  $("#worksheets-directory input[type=checkbox]:checked").each(function () {
    var itemObj = $(this).closest('li').data('item');
    items.push(itemObj);
    if (!hasEditAccess(itemObj)) return []; // this shouldn't happen, but for safety...
  });
  return items;
}

function respondToItemSelection() {
  var items = getItemSelection();
  if (items.length === 0) {
    $("#worksheets-main-actionbuttons button").hide();
  }
  else {
    $("#worksheets-main-actionbuttons button").show();

    // We don't (currently) support editing multiple directories at once, so hide the edit button in the multi-select case
    // Additionally we can only edit directories, so hide the button if the item selected is something else
    if (items.length !== 1 || items[0].type !== 'directory') {
      $("#worksheets-main-edit").hide();
    }
  }
}

function hasEditAccess(item) {
  console.log("[HasEditAccess] e = " + item.e);
  // Works out if we're allowed to edit this directory/worksheet/template.
  if (item.type == "directory") {
    return hasDirectoryPermission(item, 'e');
  } else {
    // For worksheets and templates, only the author allowed to edit/delete (except trust admin accounts)
    if (Context.user == null) return false;
    if (Context.user.type == "admin") return true;
    return Context.user.uid == item.uid || (Context.user.type == "trust" && ((item.acid && Context.user.acid == item.acid) || (item.sid && Context.user.sid == item.sid)));
  }
}

// TODO unify this with the definitions around hasDirectoryPermission() in dfm5.js
// Also "global" is not quite the right name for this attr; what it means in practice is "unsuitable as an Edit permission", but that seems overly specific :/
const permissionOptions = {
  'y': {
    text: "Admin only",
    isGlobal: false,
    isAdminOnly: true
  },
  'u': {
    text: "Me only",
    isGlobal: false,
    isAdminOnly: false
  },
  'x': {
    text: "Teachers at my school",
    isGlobal: false,
    isAdminOnly: false
  },
  's': {
    text: "Students/Teachers at my school",
    isGlobal: true,
    isAdminOnly: false
  },
  't': {
    text: "All teachers globally",
    isGlobal: true,
    isAdminOnly: false
  },
  'a': {
    text: "All users globally",
    isGlobal: true,
    isAdminOnly: false
  }
}

const directoryDivId = 'define-dir-dialog';
const directoryNameId = 'define-dir-name';
const directoryNotesId = 'define-dir-notes';
const directoryViewPermsId = 'define-dir-perms-v';
const directoryEditPermsId = 'define-dir-perms-e';

function createDefineDirectoryDiv(currentName, currentNotes, currentViewPerms, currentEditPerms) {
  // Defaults for permissions if not supplied (i.e. new directory)
  currentViewPerms = currentViewPerms || 's';
  currentEditPerms = currentEditPerms || 'x';

  // Define a function to add appropriate permission <option>s to a given <select>
  const addOptions = function (selectElement, includeGlobal, currentPermission) {
    for (var permChar in permissionOptions) {
      var perm = permissionOptions[permChar];
      if (perm.isGlobal && !includeGlobal) {
        // This is a global permission and we're not including them in this <select>
        continue;
      }
      if (perm.isAdminOnly && Context.user.type !== "admin") {
        // This is an admin-only perm, and the current user isn't an admin
        continue;
      }

      const option = $("<option></option>", { value: permChar });
      option.text(perm.text);
      if (permChar === currentPermission) {
        option.attr('selected', 'selected');
      }

      option.appendTo(selectElement);
    }
  }

  // Now start assembling the div
  const outerDiv = $("<div></div>", { id: directoryDivId });

  const nameRow = $("<div></div>");
  nameRow.appendTo(outerDiv);
  $("<label>Name:</label>").appendTo(nameRow);
  const nameInput = $("<input>", { type: 'text', id: directoryNameId, value: currentName || '' });
  nameInput.appendTo(nameRow);

  const infoRow = $("<div></div>");
  infoRow.appendTo(outerDiv);
  $("<label>Info text:</label>").appendTo(infoRow);
  const notesInput = $("<textarea></textarea>", { placeholder: '(Optional)', id: directoryNotesId });
  if (currentNotes) {
    notesInput.text(currentNotes);
  }
  notesInput.appendTo(infoRow);

  const viewPermsRow = $("<div></div>");
  viewPermsRow.appendTo(outerDiv);
  $("<label>View Permissions:</label>").appendTo(viewPermsRow);
  const viewPermsSelect = $("<select></select>", { id: directoryViewPermsId });
  addOptions(viewPermsSelect, true, currentViewPerms);
  viewPermsSelect.appendTo(viewPermsRow);

  const editPermsRow = $("<div></div>");
  editPermsRow.appendTo(outerDiv);
  $("<label>Edit Permissions:</label>").appendTo(editPermsRow);
  const editPermsSelect = $("<select></select>", { id: directoryEditPermsId });
  addOptions(editPermsSelect, false, currentEditPerms);
  editPermsSelect.appendTo(editPermsRow);

  return outerDiv;
}

function newDirectory() {
  if (!isTeacher() && !isTrustAdmin()) {
    dfmAlert("You do not have permission to manage directories and worksheet files.");
    return;
  }

  var inputTxt = createDefineDirectoryDiv().prop('outerHTML');

  dfmDialog("<h2>Create a Directory</h2>" + inputTxt, [{
    label: "Create", action: function () {
      var data = {
        name: $(`input[id=${directoryNameId}]`).val(),
        v: $(`select[id=${directoryViewPermsId}]`).val(),
        e: $(`select[id=${directoryEditPermsId}]`).val(),
        parent: Number(currentDirectory.wdid)
      };

      const notes = $(`textarea[id=${directoryNotesId}]`).val();
      if (notes) {
        data.description = notes;
      }

      if (!$.trim(data.name)) {
        dfmAlert("No name supplied");
        return false;
      }

      $.ajax({
        url: "/api/worksheets/directory",
        type: "PUT",
        contentType: false,
        processData: false,
        cache: false,
        data: JSON.stringify(data),
        success: function (data) {
          loadDirectory(currentDirectory.wdid);
        },
        error: function (j, textStatus, errorThrown) {
          dfmAlert("A problem occurred: <strong>" + j.responseText + "</strong>");
        }
      });


    }
  }]);
}

function editDirectory(directory) {
  if (!isTeacher() && !isTrustAdmin()) {
    dfmAlert("You do not have permission to manage directories and worksheet files.");
    return;
  }

  var inputTxt = createDefineDirectoryDiv(directory.name, directory.description, directory.v, directory.e).prop('outerHTML');

  dfmDialog("<h2>Edit Directory</h2>" + inputTxt, [{
    label: "Update", action: function () {
      var data = {
        wdid: directory.wdid,
        name: $(`input[id=${directoryNameId}]`).val(),
        description: $(`textarea[id=${directoryNotesId}]`).val(),
        v: $(`select[id=${directoryViewPermsId}]`).val(),
        e: $(`select[id=${directoryEditPermsId}]`).val()
      };

      if (!$.trim(data.name)) {
        dfmAlert("No name supplied");
        return false;
      }

      $.ajax({
        url: "/api/worksheets/directory",
        type: "PATCH",
        contentType: false,
        processData: false,
        cache: false,
        data: JSON.stringify(data),
        success: function (data) {
          loadDirectory(currentDirectory.wdid);
        },
        error: function (j, textStatus, errorThrown) {
          dfmAlert("A problem occurred: <strong>" + j.responseText + "</strong>");
        }
      });


    }
  }]);
}

function editSelection() {
  // This logic might change in future, but for now this is just a wrapper around editDirectory() that ensures we
  //  have exactly one directory
  var items = getItemSelection();
  if (items.length !== 1) {
    console.error(`editSelection called with ${items.length} items selected; ignoring`);
    return;
  }

  var directory = items[0];
  if (directory.type !== 'directory') {
    console.error(`editSelection called with a '${directory.type}' item selected; ignoring`);
    return;
  }

  editDirectory(directory);
}

function populateLeftTree(domElem, json) {
  // console.log(JSON.stringify(json));
  $.each(json._children, function (k, child) {
    domElem.append("<li id='wtree-" + child.wdid + "'><a href='#'>" + child.name + "</a></li>");
    if (child.wdid == currentDirectory.wdid) $("#wtree-" + child.wdid).addClass('selected');
    $("#wtree-" + child.wdid + " > a").click(function () {
      loadDirectory(child.wdid);
    });
    if (child._children) {
      $("#wtree-" + child.wdid).append("<ul></ul>");
      populateLeftTree($("#wtree-" + child.wdid + " ul"), child);
    }
  });
}


// ------------------------------------
// -- WORKSHEET LOADING / NEW WORKSHEET
// ------------------------------------

function newWorksheet(withTemplate) {

  console.log("[NewWorksheet]");
  $.modal.close();
  $("#worksheets-browser").hide();
  $("#worksheets-workspace").show();
  $("#worksheet-menu-teacher").show();
  $("#worksheet-menu-student").hide();
  $("#worksheet-furthermenu").show();

  // The condition is to preserve the 'data' object when generating a template from the Skill Explorer.
  if (!(withTemplate && currentPageState.data)) {
    currentPageState = withTemplate ? { wtid: "new" } : { wid: "new" };
    saveState("DFM - Worksheet Builder", withTemplate ? "?wtid=new" : "?wid=new");
  }

  $("#worksheets-workspace").toggleClass('template-mode', withTemplate);

  $("#worksheet-titles h1").html("New Worksheet");
  $("#worksheet-directory").val("");
  $("#worksheet-directory").dfmDirectorySelector("update");

  $("#worksheet-addquestion-button").prevAll().remove();

  removePendingWorksheetMessage();

  const canUseExamQuestions = Context.user?.type && (Context.user?.type === "admin" || Context.user?.type === "teacher");

  if (withTemplate) {
    $("#template-addquestion-button").prevAll().remove();
    $("#template-menu").show();
    $("#template-questions").show();
    $("#template-workspace").show();
    addTemplateQuestion(true);
    $(".instructional-message").remove();
    $("#worksheet-questions").append("<li class='instructional-message'>Specify the requirements for each question using the template generator on the left. When you're done, use the <strong>Generate</strong> button to generate a random worksheet.<br><br>You can then save and set this worksheet as homework in the usual way.</li>");
    $("#worksheet-addquestion-button").hide();
    $("#worksheet-menu-buttons button").prop("disabled", true);
    $("#worksheet-menu-buttons input[type=radio]").prop("disabled", true);
    madeChanges(true);
    $("#template-directory").val("");
    $("#template-directory").dfmDirectorySelector("update");

  } else {
    $(".instructional-message").remove();
    $("#worksheet-addquestion-button").show();
    $("#template-workspace").hide();

    // Only admins and teachers can use exam questions, so we can help others out by adding a single
    // blank "generated" question.
    if (!canUseExamQuestions) {
      addGeneratedQuestion();
    }

    setViewMode("edit");
    madeChanges(false);
  }

  // Hide the add-exam-question button if it's not going to do any good.
  // @TODO: Actually remove it? ...Though chances are something relies on it being in the DOM :(
  // Also worth considering if having it visible (but blocked) is actually valuable from an advertising/preview POV?
  if (!canUseExamQuestions) {
    $('#add-examquestion').hide();
  }

  currentWorksheet = undefined;
  currentTemplate = undefined;

  instantiateActionMenu(true);
  instantiateActionMenu(false);

  makeQuestionsClickable(true);

  startAutosaveTimer();

}


var prevViewMode;
function setViewMode(vmode) {
  console.log(vmode);
  $("#worksheet-vieworedit li").removeClass('selected');
  $("#worksheet-vieworedit a[href='#mode-" + vmode + "']").parent().addClass('selected');
  if (vmode === "edit") {
    $("#worksheet-questions").addClass("editable");
    if (prevViewMode != "edit") $("#worksheet-questions").sortable({
      items: "> li.question",
      stop: function (event, ui) { renumberQuestions(); madeChanges(false); },
      helper: "clone"
    });
    $("#worksheet-addquestion-button").show();
    $("#worksheet-help").show();
    $(".report-error-link").hide();
  } else {
    $("#worksheet-questions").removeClass("editable");
    if (prevViewMode == "edit") $("#worksheet-questions").sortable("destroy");

    $("#worksheet-addquestion-button").hide();
    $("#worksheet-help").hide();
    $(".report-error-link").show();
  }
  makeQuestionsClickable(vmode == "edit");
  prevViewMode = vmode;
  $("#worksheet-questions").scrollTop(0);
  $(window).resize();

}


function makeQuestionsClickable(clickable) {

  $("#worksheet-questions").find(".question-area").each(function () {
    $(this).unbind("click");
  });

  if (clickable) {
    $("#worksheet-questions").find(".question-area").each(function () {
      $(this).on("click", function () {
        let container = $(this);
        const questionNumber = container.parent().data("qnum");
        const isExamSkillQ = $(this).closest('.question').data('questionType') === 'exam';

        if (isExamSkillQ) {
          posthogEventWorksheetExamQuestionModalOpened({
            triggerId: "worksheets-exam-question-card",
            questionNumber,
            worksheet: getWorksheetDataForPosthogEvent(),
          });

          const onSelect = function (question, filters) {
            let replacingQuestion = !!container.data("question");
            if (!Array.isArray(question)) {
              putQuestionInBox(question, container, true);

              posthogEventWorksheetExamQuestionChosen({
                triggerId: "worksheets-exam-question-selector-modal-use-button",
                questionNumber,
                replacingQuestion,
                question,
                worksheet: getWorksheetDataForPosthogEvent(),
                filters
              });
            } else {
              $.each(question, function (i, v) {
                if (i == 0) {
                  putQuestionInBox(v, container, true);
                } else {
                  addExamQuestion(false);
                  container = $("#worksheet-questions").children().last().prev().find(".question-area");
                  putQuestionInBox(v, container, false);
                  replacingQuestion = false;
                }

                posthogEventWorksheetExamQuestionChosen({
                  triggerId: "worksheets-exam-question-selector-modal-use-all-parts-button",
                  questionNumber: container.parent().data("qnum"),
                  replacingQuestion,
                  question: v,
                  worksheet: getWorksheetDataForPosthogEvent(),
                  filters
                });
              });
              MathJax.typeset();
              madeChanges(false);
            }
          };

          const onCancel = function (filters) {
            posthogEventWorksheetExamQuestionModalClosedWithoutChoosing({
              triggerId: "worksheets-dismiss-exam-question-selector-modal",
              questionNumber,
              worksheet: getWorksheetDataForPosthogEvent(),
              filters
            });
          }

          selectQuestion(onSelect, onCancel);
        } else { // It's a generated question
          posthogEventWorksheetGeneratedQuestionModalOpened({
            triggerId: "worksheets-generated-question-card",
            questionNumber,
            worksheet: getWorksheetDataForPosthogEvent(),
          });

          // Create the dialog
          let courseDropdownCurrentCourse;
          let questionSelected = false;
          const onClose = () => {
            if (!questionSelected) {
              posthogEventWorksheetGeneratedQuestionModalClosedWithoutChoosing({
                triggerId: "worksheets-dismiss-generated-question-selector-modal",
                questionNumber,
                course: container.data("selectedCourse"),
                subskill: $("#keyskill-previewedquestion").data("question")?.subskill,
                worksheet: getWorksheetDataForPosthogEvent(),
              });
            }
          }
          dfmDialog("<div id='keyskill-selectcontainer'><input id='keyskill-select' type='hidden'></div>"
            + "<h2>" + name + "</h2>"
            + "<div id='keyskill-previewedquestion'>No question selected</div>",
            [{
              label: "Regenerate above",
              action: function () { generateKeySkillQuestion(); return false; }
            },
            {
              label: "Use this",
              action: function () {
                const replacingQuestion = !!container.data("question");
                questionSelected = true;
                const question = $("#keyskill-previewedquestion").data("question");
                putQuestionInBox(question, container, false);
                MathJax.typeset();
                madeChanges(false);

                posthogEventWorksheetGeneratedQuestionChosen({
                  triggerId: "worksheets-generated-question-selector-modal-use-button",
                  questionNumber,
                  replacingQuestion,
                  course: container.data("selectedCourse"),
                  question,
                  worksheet: getWorksheetDataForPosthogEvent(),
                })
              }
            }
            ],
            undefined, undefined, undefined, onClose);

          $(".dialog-buttons button").prop('disabled', true);

          // Inject the course->module->unit that was used to choose the current subskill/question.
          // It's stored directly on the question element, but is not currently "saveable" in our
          // data model, so it only persists for the current worksheet-editing session.
          // Tracks a global "most-recent" value, to allow repeat inserts of similar questions.
          $("#keyskill-select").data('skillPath', container.data('skillPath') ?? mostRecentSkillPath);

          // Update this from the clicked question element.
          // (Gets updated back out for "persistence" via the dfmSkillSelector onChange() handler.)
          // Tracks a global "most-recent" value, to allow repeat inserts of similar questions.
          mostRecentSelectedSkills = container.data('selectedSkills') ?? mostRecentSelectedSkills;

          // Configure the skill selector
          $("#keyskill-select").dfmSkillSelector({
            selectSubskills: true,
            excludeExamPractice: true,
            singleChoice: true,
            hideClearButton: true,
            onChange: function () {
              // Create a question
              generateKeySkillQuestion();

              // Store selection details for fallback use
              mostRecentSkillPath = $("#keyskill-select").data('skillPath');
              mostRecentSelectedSkills = JSON.parse($("#keyskill-select").val());

              // Store selection details against this question
              container.data('selectedSkills', mostRecentSelectedSkills);
              container.data('skillPath', mostRecentSkillPath);
              container.data("selectedCourse", courseDropdownCurrentCourse);
            },
            onCourseChange: (course) => {
              courseDropdownCurrentCourse = course;
            },
          });

          // If we already have a selected skill, show a potential question
          // @TODO: This does NOT store current params, so it always regenerates
          //        a new version of the question when opening the modal!
          if (mostRecentSelectedSkills) {
            $("#keyskill-select").dfmSkillSelector("setValue", mostRecentSelectedSkills);
            generateKeySkillQuestion();
          } else {
            // No previous subskill this session, so let's immediately trigger
            // the nested modal.
            dfmSkillSelector_openDialog($("#keyskill-select"));
          }

        }
      });
    });
  }
}



$(window).resize(function () {
  var topMenuHeight = $("#worksheets-main-menu").is(":visible") ? $("#worksheets-main-menu").outerHeight() : 0;
  var height = $(window).height() - $("#top-bar").outerHeight();
  var height2 = height - topMenuHeight - $("#worksheets-directory-menu").outerHeight() - 20;
  var height3 = height - 100;
  $("#worksheets-browser").outerHeight(height);
  $("#worksheets-directory").outerHeight(height2);
  $("#worksheets-menu").outerHeight(height3);

  var height4 = height - $("#worksheet-menu").outerHeight() - ($("#worksheet-furthermenu").is(':visible') ? $("#worksheet-furthermenu").outerHeight() : 0) - ($("#worksheet-pending-qa").is(':visible') ? $("#worksheet-pending-qa").outerHeight() : 0) - 18;
  $("#template-questions, #worksheet-questions").outerHeight(height4);
});

var lastAutosaveId;
function startAutosaveTimer() {
  if (lastAutosaveId) clearTimeout(lastAutosaveId);
  lastAutosaveId = setTimeout(function () {
    console.log("Autosaving " + unsavedChanges);
    // if(unsavedChanges)saveWorksheet(false, true) // Will finish autosaving later...
  }, 60000);
}
function stopAutosaveTimer() {
  clearTimeout(lastAutosaveId);
  lastAutosaveId = undefined;
}


function updateTotalMarks() {
  // Update number of marks.
  var totalMarks = 0;
  var useMarks = true;
  $(".question-area").each(function () {
    if ($(this).data("question") && $(this).data("question").qid) {
      if ($(this).data("question").marks) totalMarks += $(this).data("question").marks;
      else useMarks = false;
    } else {
      useMarks = false;
    }
  });
  if (currentWorksheet) {
    currentWorksheet.allqswithmarks = useMarks;
  }
  $("#worksheet-totalmarks").toggle(useMarks && totalMarks > 0).html("Total marks: <strong>" + totalMarks + "</strong>");
}

function madeChanges(isTemplate) {
  console.log("[MadeChanges] " + JSON.stringify(isTemplate));
  if (!isTemplate) {
    unsavedChanges = true;
    var permission = !currentWorksheet || hasWorksheetEditAccess(false);
    if (permission) $("#button-save").prop('disabled', false);
    updateTotalMarks();
  }
  else {
    unsavedTemplateChanges = true;
    var permission = true; // to change
    // var permission = !currentTemplate || hasWorksheetEditAccess(true);
    if (permission) $("#button-templatesave").prop('disabled', false);
  }
}

// --------------------------------------
// -- SAVING
// --------------------------------------


function saveWorksheet(saveAs, posthogTriggerId) {
  console.log("[SaveWorksheet] saveAs=" + saveAs);
  if (!Context.user) {
    dfmAlert("This functionality is available only to registered users. <a href='register.php'>Click to register</a>.");
    return;
  }

  if (!hasQuestions()) {
    dfmAlert("Cannot save worksheet: your worksheet has no questions.");
    return;
  }

  const invalidQuestions = getInvalidQuestions();
  if (invalidQuestions.length > 0) {
    dfmAlert(buildInvalidQuestionsMessage(invalidQuestions));
    return;
  }

  const originalName = $("#worksheet-titles h1").html();
  if (!currentWorksheet || saveAs) {
    var inputTxt = "<div id='worksheet-save-dialog'><label>Name:</label> <input type='text' name='save-name'><br>";
    inputTxt += "<label>Location:</label> <input type='hidden' name='location'><br><br>";
    inputTxt += "</div>";

    const saveDialogMessageId = dfmDialog(inputTxt, [{
      label: "Submit", action: function () {
        var data = { name: $("input[name=save-name]").val(), parent: Number($("input[name=location]").val()) };

        if ($.trim(data.name) == "") {
          dfmAlert("No title provided.");
          return;
        }
        $("#worksheet-titles h1").html(data.name);
        $("#worksheet-titles h1").data('originalName', originalName);
        $("#worksheet-directory").val(data.parent);
        $("#worksheet-directory").dfmDirectorySelector("update");
        currentDirectory = { wdid: data.parent };
        closeDfmMessage(saveDialogMessageId);
        saveWorksheetComplete(saveAs, undefined, posthogTriggerId);
      }
    }]);
    if (!currentWorksheet) $("input[name=save-name]").val($("#worksheet-menu h1 span").html());
    $("input[name=location]").val((currentDirectory && Context.user.sid && currentDirectory.sid == Context.user.sid) ? currentDirectory.wdid : homeDirectory.wdid); // default to current directory (provided it belongs to same school as the user), else user's home directory.
    $("input[name=location]").dfmDirectorySelector({checkAddPermission: true});
    $("input[name=location]").next().css('max-width', '270px').css('vertical-align', 'top').css('margin-top', '5px');
  }
  else saveWorksheetComplete(saveAs, false, posthogTriggerId);
}

function saveWorksheetComplete(saveAs, autosave, posthogTriggerId) {

  console.log("Saving worksheet. saveAs=" + saveAs + ", autosave=" + autosave);
  var qids = [];
  var allqswithmarks = true;
  $(".question-area").each(function () {
    var q = $(this).data("question");
    if (q && q.qid) {
      // Exam question
      if (!(q.marks > 0)) allqswithmarks = false;
      qids.push({ qid: q.qid });
    }
    else if (q && !q.qid) {
      // Key Skill question
      qids.push({ ssid: q.subskill.ssid, params: q.params });
    }
  });

  if (qids.length == 0) {
    if (autosave) return;
    dfmAlert("Your worksheet has no questions.");
    return;
  }

  // We only want to close this (non-interactive) dialog AFTER we receive a
  // response from our AJAX request, so we'll retain a reference.
  let savingMessageId;
  if (!autosave) {
    savingMessageId = dfmDialog("<p>Saving your worksheet...</p><p class='isLoading'></p>", [], true, true);
  }

  var data = { qids: qids, parent: Number($("#worksheet-directory").val()), name: $("#worksheet-titles h1").html() };
  if (saveAs && !autosave) currentWorksheet = undefined;
  if (currentWorksheet && !autosave) data.wid = currentWorksheet.wid;
  data.autosave = !!autosave;

  $.ajax({
    url: "/api/worksheets/worksheet",
    type: (currentWorksheet ? "PATCH" : "PUT"),
    contentType: false,
    processData: false,
    cache: false,
    data: JSON.stringify(data),
    success: function (worksheet) {
      // 'worksheet' contains certain things computed about the worksheet, including _subskills and the id of the worksheet if newly saved.
      currentWorksheet = worksheet;

      if (autosave) {
        $("#autosave-notification").html("Worksheet autosaved to home directory.");
        $("#autosave-notification").slideDown().delay(5000).slideUp();
        startAutosaveTimer();
        return;
      }

      currentPageState = { wid: worksheet.wid };  // data is the worksheet id
      saveState("DFM - " + $("#worksheet-titles h1").html(), "?wid=" + worksheet.wid);

      dfmAlert("Successfully saved.", () => closeDfmMessage(savingMessageId));

      unsavedChanges = false;
      $("#button-save").show();
      $("#button-save").prop('disabled', true);
      $("#button-share").prop("disabled", false);
      $("#worksheet-titles h1").html(currentWorksheet.name); // this is to avoid a strange bug with the blur event being unexpectedly fired.

      stopAutosaveTimer();
      startAutosaveTimer();
      instantiateActionMenu(false);
      // To do: There's bits of repeated code. Should have separate function 'updateWorksheetButtons' which updates buttons/interactively/menus based on new state.
      if (hasWorksheetEditAccess(false)) $("#worksheet-titles h1").addClass('editable').unbind('click').click(function () {
        updateWorksheetName(false);
      });

      removePendingWorksheetMessage();
      if (worksheet.status === 2) {
        showPendingWorksheetMessage(worksheet.wid);
      }

      if (posthogTriggerId) {
        posthogEventWorksheetSaved({
          triggerId: posthogTriggerId,
          isNewWorksheet: !saveAs && !data.wid,
          worksheet: getWorksheetDataForPosthogEvent(),
        });
      }
    },
    error: function (j, textStatus, errorThrown) {
      if (!autosave) {
        // Restore and clear the original name, so that the UI isn't out of sync
        if ($("#worksheet-titles h1").data('originalName')) {
          $("#worksheet-titles h1").html($("#worksheet-titles h1").data('originalName'));
          $("#worksheet-titles h1").data('originalName', null);
        }
        const errorMessageHtml = getErrorMessageHtmlForAjaxError(j, "There was an error when saving the worksheet.");
        dfmAlert(errorMessageHtml, () => closeDfmMessage(savingMessageId));
      }
    }
  });


}


// --------------------------------------
// -- POPUP QUESTION BROWSER
// --------------------------------------

let lastSkillSelection;
let lastSkillObject;
let lastCourseSelection;
let lastDifficultySelection;
let lastQuestionSelection;
let lastAuthorSelection;
let lastKeywords;

function selectQuestion(callback, onCancel) {
  let questionSelected = false;
  $.ui.dialog.prototype._focusTable = function () { };
  var inputTxt = "<div id='dfm-questionbrowser-dialog-menu'>";
  inputTxt += "<input type='hidden' id='keyskill-select'>";
  inputTxt += "<input type='hidden' id='dfm-questionbrowser-courses'> ";
  inputTxt += "<select id='dfm-questionbrowser-difficulty' style=''><option value=''>Difficulty: All</option><option value='1'>Difficulty: 1</option><option value='2'>Difficulty: 2</option><option value='3'>Difficulty: 3</option><option value='4'>Difficulty: 4</option></select>";
  inputTxt += " <input type='text' id='dfm-questionbrowser-keywords' placeholder='filter by keywords'>";
  inputTxt += "</div>";
  inputTxt += "<div id='dfm-questionbrowser-maincontainer'><div id='dfm-questionbrowser-selector'><ul></ul></div><div id='dfm-questionbrowser-question'>" + (Context?.user?.type == "parent" ? "<p style='margin:20px;background-color:red;color:#fff;padding:10px;border-radius:5px'>Exam questions from exam boards (e.g. Edexcel, AQA) are only available to teacher accounts, due to license restrictions.</p>" : "") + "</div></div>";
  var actions = [{
    label: "Use this question", action: function () {
      if (!lastQuestionSelection) {
        dfmAlert("No question selected.");
        return;
      }
      callback(lastQuestionSelection, getExamQuestionModalFiltersForPosthogEvent());
      lastQuestionSelection = undefined;
      questionSelected = true;
    }
  }];
  actions.push({
    label: "Use all parts of this question", action: function () {
      var data = { qids: lastQuestionSelection._allParts };
      const filters = getExamQuestionModalFiltersForPosthogEvent();
      $.ajax({
        url: "/api/questions/multiple",
        type: "POST",
        dataType: "json",
        data: JSON.stringify(data),
        success: function (data) {
          callback(data.questions, filters);
          lastQuestionSelection = undefined;
          questionSelected = true;
        },
        error: function (j, textStatus, errorThrown) {
          dfmAlert("An error occurred when fetching the parts of this question: <strong>" + j.responseText + "</strong>");
        }
      });
    }
  });

  dfmDialog(inputTxt, actions, undefined, undefined, undefined, () => {
    if (onCancel && !questionSelected) {
      onCancel(getExamQuestionModalFiltersForPosthogEvent())
    }
  });

  $("input").blur();

  $("#dfm-questionbrowser-courses").dfmExamBoardSelector({
    callback: function () {
      loadQSummaries();
      lastAuthorSelection = JSON.parse($("#dfm-questionbrowser-courses").val());
    }, light: true
  });
  $("#dfm-questionbrowser-courses").dfmExamBoardSelector("val", Context.user && Context.user.type == "parent" ? "all" : "allexam");

  $("#keyskill-select").dfmSkillSelector({
    defaultLabel: "Filter by skill",
    message: "Select a skill from your courses to filter by",
    singleChoice: true,
    onChange: function (skillSelection) {
      if (skillSelection.skills.length) {
        lastSkillObject = skillSelection.skills[0];
      }
      loadQSummaries();
      lastSkillSelection = JSON.parse($("#keyskill-select").val());
      var selectedSkill = lastSkillSelection ? lastSkillSelection.skids[0] : undefined;
      $("#dfm-questionbrowser-courses").dfmExamBoardSelector("setSkillFilter", selectedSkill);
    },
    onCourseChange: (course) => {
      lastCourseSelection = course;
    },
  });
  if (lastSkillSelection) {
    $("#keyskill-select").dfmSkillSelector("setValue", lastSkillSelection);
    $("#keyskill-select").data("skillPath", { useAllSkills: true, });
    $("#dfm-questionbrowser-courses").dfmExamBoardSelector("setSkillFilter", lastSkillSelection.skids[0]);
  }
  if (lastDifficultySelection) $("#dfm-questionbrowser-difficulty").val(lastDifficultySelection);
  if (lastAuthorSelection) $("#dfm-questionbrowser-courses").dfmExamBoardSelector("val", lastAuthorSelection);
  if (lastKeywords) $("#dfm-questionbrowser-keywords").val(lastKeywords);
  $("#dfm-questionbrowser-difficulty").change(function () {
    loadQSummaries();
    lastDifficultySelection = $(this).val();
  });
  $("#dfm-questionbrowser-courses").change(function () {
    loadQSummaries();
    lastAuthorSelection = $(this).val();
  });


  $("#dfm-questionbrowser-keywords").dfmWaitingInput(function () {
    loadQSummaries();
    lastKeywords = $("#dfm-questionbrowser-keywords").val();
  });
  loadQSummaries();
  setTimeout(function () { $("input[name=keywords]").blur() }, 30);

  $("#message-" + Context.messageCounter).addClass('dfm-questionbrowser-dialog');
  $("#message-" + Context.messageCounter).find(".dialog-buttons").addClass('dfm-questionbrowser-buttons');
  $("#message-" + Context.messageCounter).find(".dialog-buttons").children().eq(1).hide();
  $("#message-" + Context.messageCounter).find(".dialog-buttons").children().eq(1).attr('id', 'multipart-button');

}


function loadQSummaries() {
  if (Context.user && Context.user.type == "parent") return;
  var browseTopics = $("#keyskill-select").val() ? JSON.parse($("#keyskill-select").val()).skids : undefined;
  var browseDifficulty = $("#dfm-questionbrowser-difficulty").val() ? Number($("#dfm-questionbrowser-difficulty").val()) : undefined;
  var browseKeywords = $("#dfm-questionbrowser-keywords").val();
  var browseAuthor = $("#dfm-questionbrowser-courses").val() ? JSON.parse($("#dfm-questionbrowser-courses").val()) : undefined;
  var usedQuestions = getCurrentlyUsedQuestions();

  var data = {};
  if (browseKeywords) data.text = browseKeywords;
  if (browseTopics) data.skids = browseTopics;
  if (browseDifficulty) data.difficulty = browseDifficulty;
  if (browseAuthor) data.coids = browseAuthor;

  var url = "/api/questions/search";
  console.log(JSON.stringify(data));
  console.log("URL: " + url);
  $("#dfm-questionbrowser-selector ul").empty();
  $("#dfm-questionbrowser-selector").addClass('isLoading');
  $.ajax({
    url: url,
    type: "POST",
    contentType: false,
    processData: false,
    cache: false,
    dataType: "json",
    data: JSON.stringify(data),
    success: function (results) {

      $("#num-questions").html(results.num);

      $.each(results.results, function (k, summary) {
        var skillsTxt = [];
        var c = "";
        // if(summary.status==2)c = "#ff8000";
        // if(summary.status==3)c = "#ffa040";
        // if(summary.status==0)c = "rgb(237,28,36)";

        var highlight = $.inArray(summary.qid, usedQuestions) != -1;

        var summaryHTML = "<li  id='qinfo-" + summary.qid + "' " + (highlight ? "class='question-used'" : "") + "><a href='#' " + (c ? "style='background-color:" + c + "!important'" : "") + ">";
        summaryHTML += "<h1>" + replaceMathsTags(summary.content) + "</h1>";
        summaryHTML += "<h2><strong>Difficulty:</strong> <span class='difficulty-bar'>" + summary.difficulty + "</span></h2>";
        summaryHTML += "<h2><strong>Author:</strong> " + summary._authorName + "</h2>";
        // summaryHTML+= "<h2><strong>Skills:</strong> "+skillsTxt.join(" ")+"</h2>";
        summaryHTML += "</a></li>";

        $("#dfm-questionbrowser-selector ul").append(summaryHTML);
        $("#dfm-questionbrowser-selector ul").children().last().click(function () {
          $("#dfm-questionbrowser-selector ul").children().removeClass('selected');
          $(this).addClass('selected');
          $.ajax({
            url: "/api/questions/exam/" + summary.qid,
            type: "GET",
            dataType: "json",
            success: function (q) {
              dfm_generateQuestionContent($("#dfm-questionbrowser-question"), q, function () { return false; });
              $("#dfm-questionbrowser-question").find("input[type=submit]").hide();
              MathJax.typeset();
              lastQuestionSelection = q;
              $("#multipart-button").hide();
              if (q._allParts?.length > 0) {
                const allOtherParts = q._allParts.filter(p => p !== q.qid);
                if (allOtherParts.length > 0) {
                  $("#multipart-button").show();
                }
              }
            },
            error: function (j, textStatus, errorThrown) {
              dfmAlert("An error occurred: <strong>" + j.responseText + "</strong>");
            }
          });
        });
      });
      if (results.num == 0) {
        $("#dfm-questionbrowser-selector ul").append("<li>Sorry, but there are no questions which match your criteria.</li>");
      }
      $(".difficulty-bar").each(function () { $(this).dfmLevelBar(); });
      $(".difficulty-bar").dfmLevelBar("giveColour");
      MathJax.typeset();

      $("#dfm-questionbrowser-selector").removeClass('isLoading');
    },
    error: function (j, textStatus, errorThrown) {
      $("#dfm-questionbrowser-selector").removeClass('isLoading');
      dfmAlert("An error occurred: <strong>" + j.responseText + "</strong>");
    }
  });

}

function generateKeySkillQuestion() {
  if (!$("#keyskill-select").val()) return;
  var ssid = JSON.parse($("#keyskill-select").val()).ssids[0];
  if (!ssid) {
    console.log("[ERROR] Could not generate question - ssid was null!");
    return;
  }
  $(".dialog-buttons button").prop('disabled', true);
  $("#keyskill-previewedquestion").css('filter', 'opacity(0.3)');
  $.ajax({
    url: "/api/questions/keyskill/" + ssid,
    contentType: false,
    processData: false,
    type: "GET",
    dataType: "json",
    cache: false,
    success: function (data, textStatus, jqXHR) {
      $(".dialog-buttons button").prop('disabled', false);
      $("#keyskill-previewedquestion").css('filter', 'opacity(1)');
      $("#keyskill-previewedquestion").data("question", data);
      dfm_generateQuestionContent($("#keyskill-previewedquestion"), data, function () {
        return answerSubmitHandler($("#keyskill-previewedquestion"),
          function (qArea) {
            defaultResponseFunction($("#keyskill-previewedquestion"))(qArea);
            $('input[type=submit]').prop('disabled', false);
          }
        )
      });
      $("#keyskill-previewedquestion input[type=submit]").hide();
      try { MathJax.typeset(); } catch (err) { console.log(err); }
    },
    error: function (jqXHR) {
      $("#keyskill-previewedquestion").css('filter', 'opacity(1)');
      $(".dialog-buttons button[id$='-0']").prop('disabled', false); // Allow regeneration
      const errorMessageHTML = getErrorMessageHtmlForAjaxError(jqXHR, "There was an error generating this question.");
      $("#keyskill-previewedquestion").html(`<div style="padding-bottom: 12px;">${errorMessageHTML}</div>`);
    }
  });
  return false;

}

function getCurrentlyUsedQuestions() {
  var qids = [];
  $(".question-area").each(function () {
    if ($(this).data("question")) qids.push(parseInt($(this).data("question").qid));
  });
  return qids;
}




// --------------------------------------
// -- Templates
// --------------------------------------

var tCounter = 0;
function addTemplateQuestion(singleAdd) {
  tCounter++;
  var form = "";
  form += "<div style='margin-top: 15px'><label class='template-label'>Skill:</label><input type='hidden' class='template-subskill'></div>";
  form += "<div class='examonly'>";
  form += "<div style='margin-top:15px'><label class='template-label'>Board:</label><input type='hidden' class='template-board'></div>";
  form += "<div><label class='template-label'>Difficulty:</label><select name='tq-difficulty' style='padding:6px'><option value='1to3' selected>1-3</option><option value='1to4'>1-4</option><option value='1to2'>1-2</option><option value='2to3'>2-3</option><option value='2to4'>2-4</option><option value='3to4'>3-4</option><option value='1'>1 only</option><option value='2'>2 only</option><option value='3'>3 only</option><option value='4'>4 only</option></select></div>";
  form += "<div><label class='template-label'>Calculator?</label><select name='tq-calc' style='padding:6px'><option value='0'>Unspecified</option><option value='1'>Yes</option><option value='2'>No</option></select></div>";
  form += "</div>";

  var numquestions = $("#template-questions").children().length - 1;
  var lastQ;
  if (numquestions > 0 && singleAdd) {
    var lastQuestionLi = $("#template-questions").children().last().prev();
    lastQ = readTemplateQuestion(lastQuestionLi);
  }

  $("#template-questions").children().last().before("<li class='question' id='template-q-" + tCounter + "' style='padding-bottom:10px'><h1><a href='#'>&times;</a><span class='qnum'>Question</span></h1><div class='question-area'>" + form + "</div></li>");
  if (singleAdd) {
    var scroll = $("#template-questions").children().last().offset().top - $("#template-questions").offset().top + $("#template-questions").scrollTop();
    $("#template-questions").animate({ scrollTop: scroll }, "slow");
  }
  var lastQuestionLi = $("#template-questions").children().last().prev();
  lastQuestionLi.find('.examonly').hide();

  lastQuestionLi.find('.template-board').dfmExamBoardSelector({ light: true });
  lastQuestionLi.find('.template-board').dfmExamBoardSelector("val", [BOARD_ANYEXAM]);

  // Required variables for tracking user interaction with the modal.
  let selectionCount = 0;
  let userHasInteractedWithModal = false;
  let lastSelectedSubskill;
  let lastSelectedCourse;

  lastQuestionLi.find('.template-subskill').dfmSkillSelector({
    hideClearButton: true,
    singleChoice: true,
    selectSubskills: true,
    onChange: function (skillselection) {
      /**
       * This will fire once if there is an existing subskill to populate, but we
       * need to somehow check if the user has interacted with the modal.
       *
       * The only time it will not fire once for a new question is if it's the
       * first and only subskill. I think this is the best we can do to determine
       * if the user has interacted with the modal, without a larger refactor.
       */
      if (!userHasInteractedWithModal) {
        selectionCount++;
        const isFirstAndOnlyQuestion = singleAdd && numquestions === 0;
        const selectionThreshold = isFirstAndOnlyQuestion ? 0 : 1;
        userHasInteractedWithModal = selectionCount > selectionThreshold;
      }

      if (userHasInteractedWithModal) {
        posthogEventWorksheetTemplateSubskillChosen({
          triggerId: "worksheets-template-subskill-selector-item",
          questionNumber: numquestions + 1,
          replacingQuestion: !!lastSelectedSubskill,
          course: lastSelectedCourse,
          subskill: skillselection.subskills[0],
          template: getTemplateDataForPosthogEvent({ discardType: true }),
        });
      }

      // Keep track of the current subskill object.
      lastSelectedSubskill = skillselection.subskills[0];

      madeChanges(true);
      var subskillType = skillselection.subskills[0]?.type;
      if (subskillType == "e") {
        lastQuestionLi.find(".examonly").show();
        lastQuestionLi.find('.template-board').dfmExamBoardSelector("setSkillFilter", skillselection.subskills[0]?.skid);
      } else {
        lastQuestionLi.find(".examonly").hide();
      }
    },
    onCourseChange: function (course) {
      // Keep track of the current course object.
      lastSelectedCourse = course;
    },
    onOpen: function () {
      userHasInteractedWithModal = false;
      posthogEventWorksheetTemplateSubskillModalOpened({
        triggerId: "worksheets-template-question-subskill-selector",
        questionNumber: numquestions + 1,
        template: getTemplateDataForPosthogEvent(),
      });
    },
    onClose: function () {
      if (!userHasInteractedWithModal) {
        posthogEventWorksheetTemplateSubskillModalClosedWithoutChoosing({
          triggerId: "worksheets-dismiss-template-question-subskill-selector",
          questionNumber: numquestions + 1,
          course: lastSelectedCourse,
          subskill: lastSelectedSubskill,
          template: getTemplateDataForPosthogEvent(),
        })
      }
    }
  });

  lastQuestionLi.find("h1 a").click(function () {
    const question = readTemplateQuestion(lastQuestionLi);
    $(this).parent().parent().remove();
    renumberQuestions();
    madeChanges(true);

    posthogEventWorksheetTemplateQuestionRemoved({
      triggerId: "worksheets-template-question-card-remove-button",
      questionNumber: numquestions + 1,
      question: question.ssid ? question : undefined,
      template: getTemplateDataForPosthogEvent(),
    });
  });

  lastQuestionLi.find('input[type=checkbox]').click(function () { madeChanges(true) });
  lastQuestionLi.find('select').change(function () { madeChanges(true) });
  if (lastQ) {
    console.log("[LastQuestion] " + JSON.stringify(lastQ));

    if (lastQ.type) {
      lastQuestionLi.find('.examonly').toggle(lastQ.type === "e");
    }

    if (lastQ.difficulty) lastQuestionLi.find('select[name=tq-difficulty]').val(lastQ.difficulty);
    lastQuestionLi.find('select[name=tq-calc]').val(lastQ.calc);
    if (lastQ.ssid) {
      // Set values on the input so we can trigger the dfmSkillSelector with some useful context
      lastQuestionLi.find('.template-subskill').data('selectedSkills', { ssids: [lastQ.ssid] });
      lastQuestionLi.find('.template-subskill').data('skillPath', { useAllSkills: true });
      lastQuestionLi.find('.template-subskill').dfmSkillSelector("setValue", { ssids: [lastQ.ssid] }, true);
      lastQuestionLi.find('input[type=radio]').eq(0).click();
    }
    $.each(lastQ.authors, function (k, a) {
      lastQuestionLi.find('input[value=' + a + ']').prop('checked', true);
    });
    if (lastQ.board) lastQuestionLi.find('.template-board').dfmExamBoardSelector("val", lastQ.board);
  }
  renumberQuestions();
  if (singleAdd) {
    madeChanges(true);
    MathJax.typeset();
  }
}

// TODO: Do we need both this and above method?
function addTemplateQuestions(questions) {
  $("#worksheet-menu").show();
  $("#worksheet-addquestion-button").prevAll().remove();
  $("#template-addquestion-button").prevAll().remove();
  $("#template-menu").show();
  $("#template-questions").show();
  $("#back-arrow").hide();
  $("#template-workspace").show();
  $(".instructional-message").remove();
  $("#worksheet-questions").append("<li class='instructional-message'>Specify the requirements for each question using the template generator on the left. When you're done, use the <strong>Generate</strong> button to generate a random worksheet.<br><br>You can then save and set this worksheet as homework in the usual way.</li>");
  $("#worksheet-addquestion-button").hide();
  $("#worksheet-menu-buttons button").prop("disabled", true);
  $("#worksheet-menu-buttons input[type=radio]").prop("disabled", true);
  $("#worksheet-questions").show();
  $("#button-delete").hide();

  $.each(questions, function (k, q) {
    addTemplateQuestion(false);
    var lastQuestionLi = $("#template-questions").children().last().prev();
    if (q.difficulty) lastQuestionLi.find('select[name=tq-difficulty]').val(q.difficulty);
    lastQuestionLi.find('select[name=tq-calc]').val(q.calc ? q.calc : 0);

    // Set values on the input so we can trigger the dfmSkillSelector with some useful context
    lastQuestionLi.find('.template-subskill').data('selectedSkills', { ssids: [q.ssid] });
    lastQuestionLi.find('.template-subskill').data('skillPath', { useAllSkills: true });

    lastQuestionLi.find('.template-subskill').dfmSkillSelector("setValue", { ssids: [q.ssid] }, true); // set value but also trigger listener
    lastQuestionLi.find('input[type=radio]').eq(0).click();

    if (q.board) lastQuestionLi.find('.template-board').dfmExamBoardSelector('val', q.board);
  });

}


function readTemplateQuestion(li) {
  if (!li.find('.template-subskill').val()) return {};
  var ssid = JSON.parse(li.find('.template-subskill').val()).ssids[0];
  var templateQ = { ssid: ssid };
  if (li.find('.examonly').is(':visible')) {
    templateQ.difficulty = li.find('select[name=tq-difficulty]').val();
    templateQ.calc = Number(li.find('select[name=tq-calc]').val());
    templateQ.coids = JSON.parse(li.find('.template-board').val());
    templateQ.type = "e";
  } else {
    templateQ.type = "k";
  }
  return templateQ;
}

// ------------------------------------
// Generates a random worksheet based on a template.
// params:
//    qnum: if undefined, generates entire worksheet.
//          If a specific number, only regenerates that question.

async function generateRandomWorksheet(qnum) {
  var qs = [];
  $("#template-questions").children('.question').each(function (k, v) {
    qs.push(readTemplateQuestion($(this)));
  });
  console.log("[QTemplateInfoSent]: " + JSON.stringify(qs));
  var url = "/api/worksheets/generaterandomworksheet";

  if (!qnum) $("#worksheet-addquestion-button").prevAll().remove();
  $(".instructional-message").remove();
  $("#worksheet-addquestion-button").after("<li class='instructional-message'>Generating. Please wait...</li>");

  return $.ajax({
    url: url,
    type: "POST",
    contentType: false,
    processData: false,
    cache: false,
    data: JSON.stringify({ questions: qs, qnum: qnum }),
    dataType: "json",
    success: function (worksheet) {
      console.log("[WorksheetRandomlyGenerated] " + JSON.stringify(worksheet));

      $("#worksheet-menu-buttons input[type=radio]").prop("disabled", false);
      if (prevViewMode != "edit") setViewMode("edit");    // note that calling this method resets the scrolling.

      $.each(worksheet.questions, function (key, q) {

        if (qnum) {
          // Only need to replace the question we generated.
          var container = $("#worksheet-questions").children().eq(qnum - 1).find(".question-area");
          container.empty();
          putQuestionInBox(q, container, false);
          addTemplateRefreshButtonToHeader(container);
        } else {
          const isKeySkill = q.subskill && q.subskill.type == "k";
          if (isKeySkill) {
            addGeneratedQuestion(false);
          } else {
            addExamQuestion(false);
          }
          const container = $("#worksheet-addquestion-button").prev().find(".question-area");
          if (q.qid || isKeySkill) {
            putQuestionInBox(q, container, false);
            addTemplateRefreshButtonToHeader(container);
            container.parent().children("h1").children('span').first().addClass('qnum');
          }
        }
      });
      renumberQuestions();
      $(".instructional-message").remove();

      if (!qnum) {
        $("#worksheet-questions").scrollTop(0);
        $(window).resize();
      }

      $("#worksheet-titles h1").html("New Worksheet");
      $("#worksheet-directory").val("");
      $("#worksheet-directory").dfmDirectorySelector("update");

      $("#worksheet-addquestion-button").show();
      $("#worksheet-menu-buttons button").prop("disabled", false);

      $("#worksheet-menu-teacher").show();
      $("#worksheet-furthermenu").show();


      $("#button-delete").hide();
      currentWorksheet = undefined;

      madeChanges(false);
      setTimeout(function () { MathJax.typeset(); }, 300);
    },
    error: function (j, textStatus, errorThrown) {
      dfmAlert("A problem occurred generating a worksheet from the template: <strong>" + j.responseText + "</strong>");
    }
  });
}

function addTemplateRefreshButtonToHeader(container) {
  container.parent().children('h1').append("<button class='worksheetregenerate'><img src='/images/refresh_icon.svg'></button>");
  container.parent().find('.worksheetregenerate').click(async function (e) {
    e.preventDefault();
    var qnum = container.closest('li').data('qnum');
    console.log("[AboutToRegenerate]");
    await generateRandomWorksheet(qnum);

    const question = container.data("question");

    if (question && question.qid) {
      posthogEventWorksheetExamQuestionRegenerated({
        triggerId: "worksheets-exam-question-card-refresh-button",
        questionNumber: qnum,
        question: container.data("question"),
        worksheet: getWorksheetDataForPosthogEvent(),
      });
    } else {
      posthogEventWorksheetGeneratedQuestionRegenerated({
        triggerId: "worksheets-generated-question-card-refresh-button",
        questionNumber: qnum,
        question: container.data("question"),
        worksheet: getWorksheetDataForPosthogEvent(),
      });
    }

    return false;
  });

}


function saveTemplate(saveAs, posthogTriggerId) {
  if (!Context.user) {
    dfmAlert("This functionality is available only to registered users. <a href='register.php'>Click to register</a>.");
    return;
  }

  var title = $("#template-menu h1 span").html();
  if (!currentTemplate || !currentTemplate.wtid || saveAs) {
    var inputTxt = "<div class='dialog' id='template-save-dialog'><label>Name:</label> <input type='text' name='templ-name'><br>";
    inputTxt += "<label>Location:</label> <input type='hidden' name='templ-location'><br><br>";

    dfmDialog(inputTxt, [{
      label: "OK", action: function () {
        var data = { name: $("input[name=templ-name]").val(), location: $("input[name=templ-location]").val() };
        if ($.trim(data.name) == "") {
          dfmAlert("No title provided.");
          return;
        }
        $("#template-titles h1").html(data.name);
        $("#template-directory").val(data.location);
        $("#template-directory").dfmDirectorySelector("update");
        saveTemplateComplete(saveAs, undefined, posthogTriggerId);

      }
    }]);
    if (!currentTemplate) $("input[name=templ-name]").val($("#template-titles h1").html());
    $("input[name=templ-location]").val((currentDirectory && Context.user.sid && currentDirectory.sid == Context.user.sid) ? currentDirectory.wdid : homeDirectory.wdid); // default to user's home directory.
    $("input[name=templ-location]").dfmDirectorySelector({checkAddPermission: true});
  }
  else saveTemplateComplete(saveAs, false, posthogTriggerId);
}
function saveTemplateComplete(saveAs, autosave, posthogTriggerId) {
  console.log("[SavingTemplate] saveAs=" + saveAs);
  var qs = [];
  $("#template-questions").children('.question').each(function (k, v) {
    qs.push(readTemplateQuestion($(this)));
  });

  var data = { questions: qs, parent: Number($("#template-directory").val()), name: $("#template-titles h1").html() };
  if (currentTemplate) data.wtid = Number(currentTemplate.wtid);
  console.log(JSON.stringify(data));

  if (saveAs) currentTemplate = undefined;

  $.ajax({
    url: "/api/worksheets/template",
    type: (currentTemplate && currentTemplate.wtid ? "PATCH" : "PUT"),
    contentType: false,
    processData: false,
    cache: false,
    data: JSON.stringify(data),
    success: function (newTemplate) {
      dfmAlert("Successfully saved.");
      unsavedChanges = false;
      $("#button-templatesave").show();
      $("#button-templatesave").prop('disabled', true);
      if (!currentTemplate) {
        currentTemplate = newTemplate;
      }

      if ($("input[name=templateDir]").val()) {
        currentDirectory = { wdid: Number($("input[name=templateDir]").val()) };
      }

      instantiateActionMenu(true);

      if (posthogTriggerId) {
        posthogEventWorksheetTemplateSaved({
          triggerId: posthogTriggerId,
          isNewTemplate: !saveAs && !data.wtid,
          template: getTemplateDataForPosthogEvent(),
        });
      }
    },
    error: function (j, textStatus, errorThrown) {
      dfmAlert("A problem occurred: <strong>" + j.responseText + "</strong>");
    }
  });


}




// --------------------------------------------
// Full screen code
// --------------------------------------------

var fullscreen = false;
function toggleFullscreen() {
  if (!fullscreen) {
    $('body').addClass('fullscreen');
    openFullscreen();
  } else {
    $('body').removeClass('fullscreen');
    closeFullscreen();
  }
  fullscreen = !fullscreen;
  $(window).resize();
}
$(document).ready(function () {
  if (document.addEventListener) {
    document.addEventListener('webkitfullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);
  }
});
function exitHandler() {
  if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
    fullscreen = false;
    $('body').removeClass('fullscreen');
  }
}
function openFullscreen() {
  // var elem = $("#worksheet-workspace")[0];
  var elem = $("body")[0];
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
}
function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}



// --------------------------------------
// -- Page state management
// --------------------------------------

var currentPageState;

window.onpopstate = function (e) {
  if (e.state) loadFromPageState(e.state, true);
};

function loadFromPageState(state, retrievingState) {
  console.log("[RetrievingState] state=" + JSON.stringify(state) + " retrieving=" + retrievingState);
  currentPageState = state;
  if (currentPageState.wid == "new") {
    newWorksheet(false);

    posthogEventBlankWorksheetInitiated({
      triggerId: "worksheets-new-worksheet-link"
    });
  } else if (currentPageState.wdid == "home")  {
    loadHomeDirectory(false);
  } else if (currentPageState.wid) {
    loadWorksheet(currentPageState.wid, false, "worksheets-direct-worksheet-link");
  } else if (currentPageState.wtid == "new") {
    if (!currentPageState.data) {
      newWorksheet(true);
    } else {
      // Build a template from the data provided.
      var data = currentPageState.data;
      var templateToLoad = { questions: [] };
      if (data.interleave === 0) {
        var numPerSkill = Math.ceil(data.numquestions / data.ssids.length);
        console.log("Num per skill = " + numPerSkill);
        for (var i = 0; i < data.numquestions; i++) {
          var j = Math.floor(i / numPerSkill);
          var templateQ = { ssid: data.ssids[j] };
          if (data.coids) templateQ.coids = coids;
          templateToLoad.questions.push(templateQ);
        }
      } else for (var i = 0; i < data.numquestions; i++) {
        templateQ = { ssid: data.ssids[i % data.ssids.length] };
        if (data.coids) templateQ.coids = coids;
        templateToLoad.questions.push(templateQ);
      }
      loadTemplate(templateToLoad);
    }

    posthogEventWorksheetTemplateInitiated({
      triggerId: "worksheets-new-template-link",
      template: getTemplateDataForPosthogEvent({ discardType: true }),
    });
  } else if (currentPageState.wtid) {
    loadWorksheet(currentPageState.wtid, true, "worksheets-direct-template-link");
  } else if (currentPageState.wdid) {
    loadDirectory(currentPageState.wdid);
  }
}

function saveState(title, url) {
  console.log("[SaveState] title=" + title + " url=" + url + " currentPageState=" + JSON.stringify(currentPageState));
  document.title = title;
  window.history.pushState(currentPageState, null, url);

}

/**
 * Helper function to build a current worksheet object for Posthog events.
 */
function getWorksheetDataForPosthogEvent() {
  const worksheet = {}
  if (currentWorksheet?.wid) {
    worksheet.wid = currentWorksheet.wid;
  }
  if (currentWorksheet?.uid) {
    worksheet.uid = currentWorksheet.uid;
  }
  if ($("#worksheet-titles h1").html()) {
    worksheet.name = $("#worksheet-titles h1").html();
  }
  const questions = [];
  $("#worksheet-questions .question-area").each(function () {
    var q = $(this).data("question");
    if (q && q.qid) {
      // Exam question
      questions.push({ qid: q.qid });
    } else if (q && !q.qid) {
      // Key Skill question
      questions.push({ ssid: q.subskill.ssid, params: q.params });
    } else {
      // Placeholder question
      questions.push({});
    }
  });
  worksheet.questions = questions;
  return worksheet;
}

/**
 * Helper function to build a current template object for Posthog events.
 *
 * @param {Object | undefined} options
 * @param {boolean} options.discardType Whether to remove the type field from each template object.
 * The type property is not returned by the API and the readTemplateQuestion method can set it
 * incorrectly as a result. It's not worth tinkering with existing code so we can just set this
 * flag to remove it when it's not trusted.
 */
function getTemplateDataForPosthogEvent({ discardType = false } = {}) {
  const template = {}
  if (currentTemplate?.wtid) {
    template.wtid = currentTemplate.wtid;
  }
  if (currentTemplate?.uid) {
    template.uid = currentTemplate.uid;
  }
  if ($("#template-titles h1").html()) {
    template.name = $("#template-titles h1").html();
  }
  const questions = [];
  $("#template-questions").children(".question").each(function () {
    const question = readTemplateQuestion($(this));
    if (discardType) {
      question.type = undefined;
    }

    if (question.type === "e") {
      if (question.calc === 1 || question.calc === 2) {
        question.calculator = question.calc === 1;
      }

      const authorSpans = Array.from($(this).find(".dfmExamBoardSelector-light > span"));
      const authorSpansTextContext = authorSpans.map(span => span.textContent);
      if (authorSpansTextContext.length > 0) {
        question.source = authorSpansTextContext.length === 1 ? authorSpansTextContext[0] : authorSpansTextContext;
      }
    }

    questions.push(question);
  });
  template.questions = questions;
  template.includeTypeRelatedProperties = !discardType;
  return template;
}

/**
 * Helper function to build a set of filters for the exam question modal for Posthog events.
 */
function getExamQuestionModalFiltersForPosthogEvent() {
  const filters = {};
  if (lastSkillObject) {
    filters.skill = lastSkillObject;
  }
  if (lastCourseSelection) {
    filters.course = lastCourseSelection;
  }
  if (lastDifficultySelection) {
    filters.difficulty = parseInt(lastDifficultySelection);
  }
  const authorSpans = Array.from(document.querySelectorAll("#dfm-questionbrowser-dialog-menu > .dfmExamBoardSelector-light > span"));
  const authorSpansTextContext = authorSpans.map(span => span.textContent);
  if (authorSpansTextContext.length > 0) {
    filters.source = authorSpansTextContext.length === 1 ? authorSpansTextContext[0] : authorSpansTextContext;
  }
  if (lastKeywords) {
    filters.keywords = lastKeywords;
  }
  return filters;
}
